{% if (ctx.prefix || ctx.suffix) { %}
<div class="{{ctx.ofPrefix}}input-container">
{% } %}
{% if (ctx.prefix) { %}
<span class="{{ctx.ofPrefix}}input-container__affix {{ctx.ofPrefix}}input-container__affix--prefix" ref="prefix">
    {% if(ctx.prefix instanceof HTMLElement){ %}
      {{ ctx.t(ctx.prefix.outerHTML) }}
    {% } else{ %}
      {{ ctx.t(ctx.prefix) }}
    {% } %}
</span>
{% } %}
<{{ctx.input.type}}
  ref="{{ctx.input.ref ? ctx.input.ref : 'input'}}"
  {% for (var attr in ctx.input.attr) { %}
  {{attr}}="{{ctx.input.attr[attr]}}"
  {% } %}
  id="{{ctx.instance.id}}-{{ctx.component.key}}"
  {% if (ctx.suffix) { %}
    aria-labelledby="label-{{ctx.instance.id}}-{{ctx.component.key}} {{ctx.instance.id}}-{{ctx.component.key}} suffix-{{ctx.instance.id}}-{{ctx.component.key}}"
  {% } %}
>{{ctx.input.content}}</{{ctx.input.type}}>
{% if (ctx.component.showCharCount) { %}
<span class="charcount" ref="charcount"></span>
{% } %}
{% if (ctx.component.showWordCount) { %}
<span class="wordcount" ref="wordcount"></span>
{% } %}
{% if (ctx.suffix) { %}
<span class="{{ctx.ofPrefix}}input-container__affix {{ctx.ofPrefix}}input-container__affix--suffix" ref="suffix" id="suffix-{{ctx.instance.id}}-{{ctx.component.key}}">
    {% if(ctx.suffix instanceof HTMLElement){ %}
      {{ ctx.t(ctx.suffix.outerHTML) }}
    {% } else{ %}
      {{ ctx.t(ctx.suffix) }}
    {% } %}
</span>
{% } %}
{% if (ctx.prefix || ctx.suffix) { %}
</div>
{% } %}

{% if (ctx.component?.openForms?.requireVerification) { %}

<div class="utrecht-alert utrecht-alert--warning">
  <div class="utrecht-alert__icon">
    <span class="utrecht-icon" role="presentation" aria-hidden="true">
      <i class="fa fas fa-exclamation-triangle"></i>
    </span>
  </div>
  <div class="utrecht-alert__message">
    {{ctx.t('You must verify this email address to continue.')}}
  </div>
</div>

<button ref="verifyButton" class="utrecht-button utrecht-button--primary-action">
  {{ctx.t('Verify')}}
</button>
{% } %}
